var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppDialog',{attrs:{"content":"Are you sure you want to delete?","buttons":_vm.buttons,"header":_vm.header,"show":_vm.show},on:{"hide":_vm.cancelDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }